module.exports = __webpack_public_path__ + "static/media/35.c3d85415.jpg";